import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Badge from 'react-bootstrap/Badge'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faTimesCircle,
  faChevronCircleDown,
  faBars,
  faChevronCircleUp
} from '@fortawesome/free-solid-svg-icons'
import { upperCase } from 'lodash'

function WeightForm({ activeBadge, setActiveBadge, disabled }) {
  const [badgeHover, setBadgeHover] = useState('')

  const weightOptions = [
    { value: 'off', icon: faTimesCircle },
    { value: 'low', icon: faChevronCircleDown },
    { value: 'med', icon: faBars },
    { value: 'high', icon: faChevronCircleUp }
  ]

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center">
        <div className="fw-bold">Weight</div>
        <div>
            {weightOptions.map((w) => (
              <Badge
                key={`weighting-${w.value}`}
                className={`text-primary p-2 ms-1 ${
                  activeBadge === w.value
                    ? 'badge-primary'
                    : badgeHover === w.value
                    ? 'bg-light'
                    : 'bg-white'
                }`}
                style={{ cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.5 : 1 }}
                onClick={() => {
                  if (!disabled) setActiveBadge(w.value)
                }}
                onMouseEnter={() => setBadgeHover(w.value)}
                onMouseLeave={() => setBadgeHover('')}
              >
                {activeBadge === w.value && (
                  <FontAwesomeIcon icon={w.icon} className="me-1" />
                )}
                {upperCase(w.value)}
              </Badge>
            ))}
          </div>
      </div>
    </div>
  )
}

WeightForm.propTypes = {
  activeBadge: PropTypes.string,
  setActiveBadge: PropTypes.func.isRequired,
  disabled: PropTypes.bool
}

export default WeightForm